export enum ShapeType {
  PREDEFINED_SHAPE = 'Predefined shape',
  DRAWN_SHAPE = 'Drawn shape',
  FAUX_SHAPE = 'Faux shape',
}

export enum DiagonalCornerOptions {
  INSIDE_CORNER = 'Inside Corner',
  OUTSIDE_CORNER = 'Outside Corner',
  REMOVE_DIAGONAL_CORNER = 'Remove Diagonal Corner',
}
